import script from "./CollapsiblePropertySafetyChecks.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertySafetyChecks.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertySafetyChecks.vue?vue&type=style&index=0&id=2f498b3c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f498b3c"]])

export default __exports__